<appTable v-if="shouldRenderConfig" :tableName="name"  v-bind:tableClass="getClassName">
    <appInformation></appInformation>
</appTable>
